const LOCAL_API_BASE_URL = 'http://localhost:8000';
const PRODUCTION_API_BASE_URL = 'https://api.exanta.ai';

const resolveApiBaseUrl = () => {
  if (typeof window === 'undefined') {
    return PRODUCTION_API_BASE_URL;
  }

  const { hostname } = window.location;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isExantaHost = hostname === 'exanta.ai' || hostname.endsWith('.exanta.ai');

  if (isLocalhost) {
    return LOCAL_API_BASE_URL;
  }

  if (isExantaHost) {
    return PRODUCTION_API_BASE_URL;
  }

  return PRODUCTION_API_BASE_URL;
};

const buildUrl = (path) => {
  const baseUrl = resolveApiBaseUrl();
  return new URL(path, baseUrl).toString();
};

const parseJsonSafely = async (response) => {
  const text = await response.text();

  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch (error) {
    console.warn('Failed to parse JSON response', error);
    return null;
  }
};

export const apiRequest = async (path, options = {}) => {
  const {
    method = 'GET',
    body,
    token,
    mode,
    headers: customHeaders,
    ...rest
  } = options;

  const url = buildUrl(path);
  const headers = {
    ...customHeaders
  };

  if (body !== undefined) {
    headers['Content-Type'] = 'application/json';
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const requestOptions = {
    method,
    headers,
    mode,
    ...rest
  };

  if (body !== undefined) {
    requestOptions.body = JSON.stringify(body);
  }

  console.log('API request', {
    url,
    method,
    body,
    hasToken: Boolean(token)
  });

  const response = await fetch(url, requestOptions);
  const data = await parseJsonSafely(response);

  console.log('API response', {
    url,
    status: response.status,
    ok: response.ok,
    data
  });

  if (!response.ok) {
    const message = data && (data.detail || data.message) ? (data.detail || data.message) : 'Request failed';
    throw new Error(message);
  }

  return data;
};
